import React, { useState } from "react";
import "./CustomTabsPreview.scss";

import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@material-ui/core";

import VideoCards from "../VideoCards";
import ProgressBar from "../../atoms/ProgressBar";
import { ReactComponent as TrophyBlue } from "../../../assets/img/icons/trophyBlue.svg";

import { update_current_tab_index } from "../../../store/actions/updateCurrentViewData";

import { PartProvider } from "../../contexts";
import PillTabs from "../../molecules/PillTabs/PillTabs";
import { ReactComponent as LockIcon } from "../../../assets/img/icons/lockNavy.svg";
import { CircularLoader } from "../../atoms/Loaders";

import { ProgrammeStep } from "../../../types/ProgrammeOverview";

interface CustomTabPanelProps {
  children: React.ReactNode;
  value: any;
  index: any;
}

const CustomTabPanel: React.FC<CustomTabPanelProps> = (
  props: CustomTabPanelProps
) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`custom-tabpanel-${index}`}
      aria-labelledby={`custom-tab-${index}`}
      {...other}
    >
      {value === index && <> {children}</>}
    </div>
  );
};

interface Props {
  stepData: ProgrammeStep;
}

const CustomTabsPreview: React.FC<Props> = ({ stepData }) => {
  const dispatch = useDispatch();
  const currentTabIndex = useSelector(
    (state: any) => state.currentViewData.currentTabIndex
  );

  const [value, setValue] = useState(() => {
    if (isNaN(currentTabIndex)) {
      dispatch(update_current_tab_index(0));
      return 0;
    }
    return currentTabIndex;
  });
  const partSlugShort =
    "part-" +
    (currentTabIndex + 1).toLocaleString("en-UK", {
      minimumIntegerDigits: 2,
    });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const additionalData = (partSlug, partTitle) => {
    return {
      programmeSlug: stepData.programmeSlug,
      stepTitle: stepData.title,
      stepSlug: stepData.stepSlug,
      partSlugShort: partSlugShort,
      partSlug: partSlug,
      partTitle: partTitle,
    };
  };

  const handleTabClick = (index) => {
    dispatch(update_current_tab_index(index));
  };

  return stepData ? (
    <div className="custom-tabs">
      {stepData.stepNumber !== 0 && (
        <PillTabs
          stepData={stepData}
          value={value}
          handleChange={handleChange}
          handleTabClick={handleTabClick}
        />
      )}
      <div className="tab-body__container">
        {stepData &&
          stepData.parts.map((item, index) => {
            return (
              <CustomTabPanel value={value} index={index} key={item.title}>
                <div className="lock-state">
                  <LockIcon></LockIcon>
                </div>

                {stepData.stepNumber !== 0 && (
                  <h2 className="part__title">{item.title}</h2>
                )}
                {stepData.stepNumber === 0 && (
                  <h1 className="part__title">{item.title}</h1>
                )}
                <Grid
                  container
                  justifyContent="center"
                  style={{ padding: "0 7px" }}
                >
                  <Grid item xs={12} sm={7}>
                    <div className="master-progress-bar__container">
                      <div className="master-progress-bar__with-text">
                        <p className="master-progress-bar__text">0% Complete</p>
                        <ProgressBar progress={0.01} />
                      </div>
                      <div className="master-progress-bar__icon">
                        <TrophyBlue />
                      </div>
                    </div>
                  </Grid>
                </Grid>

                <PartProvider state={item}>
                  <VideoCards
                    data={item.sections}
                    additionalData={additionalData(item.slug, item.title)}
                  />
                </PartProvider>
              </CustomTabPanel>
            );
          })}
      </div>
    </div>
  ) : (
    <CircularLoader />
  );
};

export default CustomTabsPreview;
